var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"phone-and-mail"},[_c('RomatchIcon',{attrs:{"name":"phone","size":"18px"}}),_c('span',{staticClass:"phone"},[_vm._v("+31 (0)43 70 74 417")]),_c('RomatchIcon',{attrs:{"name":"envelop","size":"18px"}}),_c('span',[_vm._v("info@rondagroep.nl")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }